'use client';
import { getAnimationStyles } from './getAnimationStyles/getAnimationStyles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getAnimationContextStyles = function(theme, params) {
    if (!params.animate) {
        return {
            animation: "none"
        };
    }
    var _theme_fn = theme.fn, cover = _theme_fn.cover, gradient = _theme_fn.gradient, primaryShade = _theme_fn.primaryShade, themeColor = _theme_fn.themeColor, rgba = _theme_fn.rgba;
    var animation = params.animation;
    var accentColor = primaryShade(themeColor(params.accentColor));
    switch(animation){
        case "wave":
            {
                return {
                    position: "relative",
                    overflow: "hidden",
                    "&::after": _extends({
                        zIndex: 11,
                        /* Предотвращает мерцание во время hydration */ transform: "translateX(-100%)",
                        content: '""'
                    }, cover(0), getAnimationStyles(params), {
                        background: gradient.linear(90, "transparent 69%", "" + rgba(accentColor, 0.37) + " 86%", "transparent")
                    })
                };
            }
        case "pulse":
            {
                return _extends({}, getAnimationStyles(params));
            }
        default:
            {
                return _extends({}, getAnimationStyles(params));
            }
    }
};

export { getAnimationContextStyles };
